import { colors } from '~/styles';

import './spinner.scss';

const DEFAULT_COLOR = colors['stone-500'];

type Props = {
    className?: string;
    color?: string;
    size?: number;
    useDefaultColor?: boolean;
    isCentered?: boolean;
    isFill?: boolean;
    children?: React.ReactNode;
};

export default function Spinner({
    className,
    useDefaultColor = false,
    color = DEFAULT_COLOR,
    size = 30,
    isCentered,
    isFill = false,
    children,
}: Props): JSX.Element {
    const strokeColor = useDefaultColor ? DEFAULT_COLOR : color || 'currentColor';

    return (
        <span
            className={`${className} ${isCentered ? 'centered-spinner' : ''} ${
                isFill ? 'spinner--fill' : ''
            }`}
        >
            <svg
                className='spinner'
                fill='currentColor'
                width={`${size}px`}
                height={`${size}px`}
                viewBox='0 0 66 66'
                xmlns='http://www.w3.org/2000/svg'
            >
                <circle
                    className='path'
                    fill='none'
                    stroke={strokeColor}
                    strokeWidth='6'
                    strokeLinecap='round'
                    cx='33'
                    cy='33'
                    r='30'
                />
            </svg>
            {children}
        </span>
    );
}
